var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-wrapper"},[(this.events)?_c('EventList',{attrs:{"events":this.events},on:{"event-selected":_vm.eventSelected,"event-download":_vm.downloadItem,"event-delete":_vm.eventDelete}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }